import * as React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  required,
} from "react-admin";

export const CreateCoupon = (props) => (
  <Create {...props}>
    <SimpleForm>
      <NumberInput source="nominal" validate={[required()]} />
      <TextInput source="fuel_type" validate={[required()]} />
      <TextInput source="coupon_code" validate={[required()]} />
      <TextInput source="valid_period" validate={[required()]} />
      <TextInput source="coupon_serial" validate={[required()]} />
    </SimpleForm>
  </Create>
);
export default CreateCoupon;
